// src/utils/encrypt.js
import CryptoJS from 'crypto-js';

const secretKey = '6ae8d14bf34e5a8d27f937b6d21ef345f98c76e34af8729bd79c5ab836f47a29';
const secretKey2 = 'a3f9d7b6c5e4a1f0c8d2e6b7a9c4d3f1e2b8a7c6d5e4f9a0b1c2d3e6f7a8c9d0';

export function encryptData(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
}

export function decryptData(cipherText) {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

export function smartEncryptData(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey2).toString();
}

export function smartDecryptData(cipherText) {
  const bytes = CryptoJS.AES.decrypt(cipherText, secretKey2);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

